import React from 'react'
import agent from '../agent'
import CoinTransactionList from './widgets/CoinTransactionList';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import Pager from 'react-pager'
import { DatePicker } from 'antd';
import 'antd/dist/antd.css';
import moment from 'moment';

import {
  COIN_LIST_PAGE_LOADED,
  COIN_LIST_NEXT_PAGE_LOADED,
  COIN_LIST_SEARCH_LOADED,
  COIN_LIST_PAGE_UNLOADED,
  UPDATE_FIELD_AUTH,
  COIN_TRANSACTION_GO,
  CHANGE_DATE_STRINGS,
  UPDATE_FIELD_TRANSACTION_SEARCHTERM,
} from '../constants/actionTypes'
import role from '../util/role'
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY/MM/DD';

const mapStateToProps = state => ({
  ...state.coins,
  currentUser: state.common.currentUser,
  appName: state.common.appName,
  token: state.common.token,
  coinTransactionKey: state.auth.coinTransactionKey,
  date_from: state.common.date_from,
  date_to: state.common.date_to
});

const mapDispatchToProps = dispatch => ({
  onLoad: (payload, pageIndex, terms, date_from, date_to) =>
    dispatch({ type: COIN_LIST_PAGE_LOADED, payload, currentPage: pageIndex, searchTerm: terms, date_from, date_to }),
  onLoadNextPage: (payload, pageIndex, terms, date_from, date_to) => {
    dispatch({ type: COIN_LIST_NEXT_PAGE_LOADED, payload, currentPage: pageIndex, searchTerm: terms, date_from, date_to })
  },
  onSearchTransactions: (payload, pageIndex, terms, status, date_from, date_to) => {
    dispatch({ type: COIN_LIST_SEARCH_LOADED, payload, currentPage: pageIndex, searchTerm: terms, date_from, date_to })
  },
  onUnload: () =>
    dispatch({ type: COIN_LIST_PAGE_UNLOADED }),
  onChangeKey: value =>
    dispatch({ type: UPDATE_FIELD_AUTH, key: 'coinTransactionKey', value }),
  onChangeDateStrings: (date_from, date_to) =>
    dispatch({ type: CHANGE_DATE_STRINGS, date_from, date_to }),
  onRedirect: (payload) => {
    dispatch({ type: COIN_TRANSACTION_GO, payload })
  },
  onChangeSearchTerm: value =>
    dispatch({ type: UPDATE_FIELD_TRANSACTION_SEARCHTERM, key: 'searchTerm', value }),
});

class Coins extends React.Component {
  constructor() {
    super()
    this.changeKey = ev => this.props.onChangeKey(ev.target.value)

    this.redirect = (coinTransactionKey) => ev => {
      console.log(coinTransactionKey)
      ev.preventDefault()
      this.props.onRedirect(coinTransactionKey)
    }
    this.changeSearchTerm = (ev) => this.props.onChangeSearchTerm(ev.target.value)
    this.searchTransactions = () => ev => {
      ev.preventDefault()
      const pageIndex = 1;
      const terms = this.props.searchTerm || ''
      const date_from = this.props.date_from || ''
      const date_to = this.props.date_to || ''
      const payload = agent.Coins.transactions(pageIndex, terms, date_from, date_to)
      this.props.onSearchTransactions(payload, pageIndex, terms, date_from, date_to)
    }
  }

  componentWillMount() {
    const pageIndex = 1;
    const terms = ''
    const date_from = ''
    const date_to = ''
    const payload = agent.Coins.transactions(pageIndex, terms, date_from, date_to)
    this.props.onLoad(payload, pageIndex, terms, date_from, date_to);

  }

  componentWillUnmount() {
    this.props.onUnload();
  }
  handlePageChanged(newPage) {
    const pageIndex = newPage + 1;
    const terms = this.props.searchTerm || ''
    const date_from = this.props.date_from || ''
    const date_to = this.props.date_to || ''
    const payload = agent.Coins.transactions(pageIndex, terms, date_from, date_to)
    this.props.onLoadNextPage(payload, pageIndex, terms, date_from, date_to);
  }
  handleChangeDateStrings(dates, dateStrings) {
    var unixFrom = dateStrings[0] ? moment(dateStrings[0]).format('X') : ''
    var unixTo = dateStrings[1] ? moment(moment(dateStrings[1]).format('YYYY-MM-DD 23:59:59')).format('X') : ''
    this.props.onChangeDateStrings(unixFrom, unixTo)
  }
  render() {

    const coinTransactionKey = this.props.coinTransactionKey
    const date_from = this.props.date_from ? moment(moment(this.props.date_from * 1000).format('YYYY-MM-DD')) : ''
    const date_to = this.props.date_to ? moment(moment(this.props.date_to * 1000).format('YYYY-MM-DD')) : ''

    return (
      <div class='pane'>
        {/*role.can(this.props.currentUser.role, COIN_TRANSACTION_GO) ?
          <Link className="buttonTop" to='/coins/send'><i className="icon ion-android-add-circle"></i></Link> : null
        */}
        <h1>Transaction List</h1>
        <div className="filters">
          <div className="filterSearch">
            <RangePicker
              ranges={{ 'This Month': [moment().startOf('month'), moment()], Today: [moment(), moment()] }}
              value={[date_from, date_to]}
              onChange={this.handleChangeDateStrings.bind(this)}
            />
            <input type="text" placeholder="find transactions" value={this.props.searchTerm} onChange={this.changeSearchTerm} />
            <button type="submit" onClick={this.searchTransactions()}>Find</button>
            {/* <form onSubmit={this.redirect(coinTransactionKey)}>
              <input type="text" value={coinTransactionKey} onChange={this.changeKey} placeholder="transaction id" />
              <button type="submit">Go</button>
            </form> */}
          </div>
        </div>
        <CoinTransactionList transactions={this.props.transactions} loading={this.props.loading} />
        {
          this.props.transactions && this.props.transactions.length > 0 ?
            <Pager
              total={this.props.totalPage || 0}
              current={this.props.currentPage - 1}
              visiblePages={7}
              titles={{ first: '<<', last: '>>' }}
              onPageChanged={this.handlePageChanged.bind(this)}
            />
            : null
        }
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Coins);



// WEBPACK FOOTER //
// ./src/components/Coins.js